export default __webpack_public_path__ + "static/cards-dont-192fccb782860600ddbf357a1e3c21d9.png";